export default __webpack_public_path__ + "static/media/152.0081f0d4.gif";